// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"styles_socialMedia__2DpmC","glowing":"styles_glowing__2ERSM"};